import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { todayIn } from "./dates";
// Derived reporting months and alerts change without a database write/NOTIFY at midnight.
export function watchOrgDate(timezone: string, changed: () => void): () => void {
  let previous = todayIn(timezone);
  const timer = setInterval(() => {
    const next = todayIn(timezone);
    if (next !== previous) { previous = next; changed(); }
  }, 30_000);
  return () => clearInterval(timer);
}
export function useOrgClock(timezone: string) {
  const qc = useQueryClient();
  useEffect(() => watchOrgDate(timezone, () => {
    void qc.invalidateQueries({ predicate: (q) => ["loans", "summary", "goals"].includes(String(q.queryKey[0])) });
  }), [qc, timezone]);
}
